import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

function Accessibility() {
  
  return (
    <Container maxWidth="sm">
      <Typography variant="h6">הצהרת נגישות</Typography>
      <Typography variant="body1">
        <strong> מבוא</strong>
        <br />
        קבוצת ניאופרם פועלת מתוך רצון לתת שירות נגיש לכלל לקוחותיה מתוך אחריות
        והכלה וכמתחייב בחוק. עמוד זה הוקם בהתאם לדרישות תקנות שוויון זכויות
        לאנשים עם מוגבלות (התאמות נגישות לשירות), התשע"ג-2013, במטרה ליידע אותך
        כיצד ניתן ליהנות מהסדרי הנגישות של החברה. לשאלות, בירורים או הבהרות ניתן
        לפנות למוקד שירות הצרכנים של קבוצת ניאופרם:טל': 1-800-250-255 במידה
        והינך נדרש לאמצעי תקשורת חלופי לטלפון ניתן לפנות בכתב בדוא"ל:
        <a href="mailto:callcenter@neopharmgroup.com">
          callcenter@neopharmgroup.com
        </a>{" "}
        רכזת הנגישות הארגונית הינה קרן מורנו –
        <a href="mailto: negishut@neopharmgroup.com">
          negishut@neopharmgroup.com
        </a>
        , טל' 03-9373750
      </Typography>
      <br />

      <Typography variant="body1">
        <strong> נגישות האתר</strong>
        <br />
        אתר זה מופעל על ידי תוכנת הנגשה המופעלת באמצעות שרת הנגשה ייעודי. התוכנה
        מאפשרת לאתר לעמוד בהנחיות לנגישות תכנים באינטרנט WCAG 2.0 ברמת AA.
        התוכנה כפופה לתנאי השימוש של היצרן.
      </Typography>
      <br />

      <Typography variant="body1">
        <strong> כיצד עובדת ההנגשה באתר:</strong>
        <br />
        באתר מוצב תפריט הנגשה. לחיצה על התפריט מאפשרת פתיחת כפתורי ההנגשה. לאחר
        בחירת נושא בתפריט יש להמתין לטעינת הדף. לפירוט אודות הנגשת האתר ניתן
        ללחוץ על כפתור הנגישות.
      </Typography>
      <br />

      <Typography variant="body1">
        <strong> הבהרה</strong>
        <br />
        חרף מאמצנו לאפשר גלישה באתר נגיש עבור כל דפי האתר, יתכן ויתגלו דפים באתר
        שטרם הונגשו, או שטרם נמצא הפתרון הטכנולוגי המתאים. אנו ממשיכים במאמצים
        לשפר את נגישות האתר, ככל האפשר, וזאת מתוך אמונה ומחויבות מוסרית לאפשר
        שימוש באתר לכלל האוכלוסייה, לרבות אנשים עם מוגבלויות.
      </Typography>
      <br />

      <Typography variant="body1">
        <strong> דרכי יצירת קשר</strong>
        <br />
        במידה ויש לך שאלות, בקשות, הצעות לשיפור נשמח לקבל את פנייתך ולסייע
        באמצעות: דוא"ל :{" "}
        <a href="mailto:callcenter@neopharmgroup.com">
          callcenter@neopharmgroup.com
        </a>{" "}
        טלפון : 1-800-250-255 בנוסף, ניתן לפנות גם אל רכזת הנגישות בחברה: קרן
        מורנו:
        <a href="mailto:callcenter@neopharmgroup.com">
          callcenter@neopharmgroup.com
        </a>
      </Typography>
      <br />

      <Typography variant="body1">
        <strong> בקשה להתאמות נגישות</strong>
        <br />
        במידה והנך נדרש להתאמות ו/או הסדרי נגישות בעת ביצוע הרכישה ו/או לצורך
        תיאום וקבלת המשלוח אנא ציין זאת במייל ל- negishut@neopharmgroup.com,
        בצירוף מספר הזמנה ותאריך רכישה.
      </Typography>
      <br />
    </Container>
  );
}

export default Accessibility;
